// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2zieI","disabled":"FileBtn_disabled__3wVF4","warn":"FileBtn_warn__2GBKI","fade":"FileBtn_fade__2WtYS"};